function PhoneCallsDashboardReducer(state, action) {
  switch (action.type) {
    case "set_calls":
      return {
        ...state,
        calls: action.calls,
        completedCalls: action.completedCalls,
        settings: action.settings
      };
  }
}
export default PhoneCallsDashboardReducer;
